export default (httpClient) => ({
    getTemplates(personId) {
      return httpClient.get(`/v3/person/file/library/templates/${personId}`);
    }
  });